"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.watch = void 0;
/**
 * Subscribes to a reactive value, skips the first `skip` emissions, and calls
 * `callback` with the latest value after `debounce` ms of silence.
 *
 * @returns Returns a cleanup function that unsubscribes and cancels any pending timer.
 */
const watch = (source, debounce = 0, skip = 0, callback) => {
    let remaining = skip;
    let timer = 0;
    const unsub = source.subscribe(() => {
        if (remaining > 0) {
            remaining--;
            return;
        }
        if (timer)
            clearTimeout(timer);
        if (debounce > 0) {
            timer = setTimeout(() => {
                timer = 0;
                callback(source.value);
            }, debounce);
        }
        else {
            callback(source.value);
        }
    });
    return () => {
        unsub();
        if (timer)
            clearTimeout(timer);
    };
};
exports.watch = watch;
